import { useContext } from "react";
import {
    SupportChatContext,
    type SupportChatContextValue,
} from "./SupportChatContext";

export function useOptionalSupportChat(): SupportChatContextValue | null {
    return useContext(SupportChatContext);
}

export function useSupportChat(): SupportChatContextValue {
    const ctx = useOptionalSupportChat();
    if (!ctx) {
        throw new Error(
            "useSupportChat must be used inside <SupportChatProvider>",
        );
    }
    return ctx;
}
